import { Box, BoxProps, styled, TableBody, TableCell } from "@mui/material";
import { styledOmitPropsOptions } from "../../theme/styled.helpers";

export const PersonsAccordionBodyBox = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" },
        gridTemplateRows: { xs: "repeat(4, auto)", md: "repeat(2, auto)" },
        backgroundColor: theme.palette.divider,
        gridGap: "2px 1px",
    }),
);

export const PersonsAccordionBodyInnerBox = styled(
    (
        props: BoxProps & {
            $gridRowMd?: string;
            $gridColumnMd?: string;
        },
    ) => {
        return <Box {...props} />;
    },
    styledOmitPropsOptions,
)(({ theme, $gridRowMd, $gridColumnMd }) =>
    theme.unstable_sx({
        backgroundColor: theme.palette.background.paper,
        gridRow: { xs: "auto", md: $gridRowMd ?? "auto" },
        gridColumn: { xs: "auto", md: $gridColumnMd ?? "auto" },
    }),
);

export const PersonsAccordionLastCell = styled(TableCell)(({ theme }) =>
    theme.unstable_sx({
        borderBottom: 0,
    }),
);

export const PersonsAccordionTableBody = styled(TableBody)(({ theme }) =>
    theme.unstable_sx({
        // Remove left padding from first cell and right padding from last cell in each row
        "& tr > td:first-of-type": { paddingLeft: 0 },
        "& tr > td:last-of-type": { paddingRight: 0 },
    }),
);

export const PersonsAccordionAddressBox = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        pt: theme.spacing(3),
    }),
);
